import Content from './components/content'
import Thumbnail from './components/thumbnail'

const PdfPreview = ({ content, setPdfView }) => {
  return (
    <div className="pdf-preview-container d-flex flex-lg-row flex-column justify-content-between" style={{ backgroundColor: "#313135" }}>
      <div className="col-lg-5">
        <Thumbnail thumbnailLink={content?.thumbnailLink} setPdfView={setPdfView} />
      </div>
      <div className="col-lg-6">
        <Content content={content} setPdfView={setPdfView} />
      </div>
    </div>

  )
}

export default PdfPreview